export default "__VITE_ASSET__DFUevUZC__"